module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/dashboard/components/minha-conta/minha-conta.component.html
// module id = ./src/app/modules/dashboard/components/minha-conta/minha-conta.component.html
// module chunks = main